import script from "./BpmnFireEventModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnFireEventModal.vue?vue&type=script&setup=true&lang=js"

import "./BpmnFireEventModal.vue?vue&type=style&index=0&id=6ded42e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ded42e1"]])

export default __exports__